// Returns the maximum number of days for consecutive term months.
const MAX_DAYS_BY_TERM: Record<number, number> = {
    1: 31,
    2: 62,
    3: 92,
    4: 123,
    5: 153,
    6: 184,
    7: 215,
    8: 245,
    9: 276,
    10: 306,
    11: 337,
    12: 366,
    13: 397,
    14: 428,
    15: 458,
    16: 489,
    17: 519,
    18: 550,
    19: 581,
    20: 611,
    21: 642,
    22: 672,
    23: 703,
    24: 731,
    25: 762,
    26: 793,
    27: 823,
    28: 854,
    29: 884,
    30: 915,
    31: 946,
    32: 976,
    33: 1007,
    34: 1037,
    35: 1068,
    36: 1096,
}

export default function getMaxDaysForTermMonths(termMonths: number): number {
    return MAX_DAYS_BY_TERM[termMonths];
}